// Types
export interface KickVideoThumbnail {
    url?: string;
    src?: string;
}

export interface KickVideoLivestream {
    session_title?: string;
    duration?: number;
    thumbnail?: KickVideoThumbnail | string | null;
}

export interface KickVideo {
    id: string | number;
    session_title?: string;
    thumbnail?: KickVideoThumbnail | string | null;
    livestream?: KickVideoLivestream;
    duration?: number;
    views?: number;
    created_at?: string;
    video: {
        uuid: string;
    };
}

export interface FormattedStream {
    id: string | number;
    title: string;
    thumbnail: string | null;
    duration: string | null;
    views: string;
    date: string;
    url: string;
}

export interface LiveStream {
    id: string | number;
    session_title: string;
    thumbnail?: { url?: string };
    viewer_count?: number;
}

// Constants
export const KICK_USERNAME = 'sokogambles';
